export default "__VITE_ASSET__DyaB9cr9__"